/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  CountryCode,
  Edge,
  EdgeType,
  StoreAddress,
} from '@/models';

import customers from './customers';
import FulfillmentService from './fulfillmentServices';

import { id } from './id';

const edges: Edge[] = [];

// Link the first customer with Addresses.Seven.
edges.push({
  src: FulfillmentService.SevenEleven,
  dest: customers[0],
  type: EdgeType.CustomerAddressesForFulfillmentService,
  data: [
    {
      id: id(),
      name: '楊雙雙',
      country: CountryCode.TWN,
      address1: '工商路16號',
      city: '新北市',
      stateOrRigion: '五股區',
      phone: '+886912345678',
      storeId: '967983',
      storeName: '弘龍門市',
    },
    {
      id: id(),
      name: '楊喬喬',
      country: CountryCode.TWN,
      address1: '工商路150號',
      city: '新北市',
      stateOrRigion: '五股區',
      phone: '+886987654321',
      storeId: '956835',
      storeName: '福臨門市',
    },
  ] as StoreAddress[],
});

export default edges;
